<template>
<a-spin :spinning="spinning" tip="Loading...">
    <div class="card mb-3">
        <div class="row no-gutters">
            <div class="col-md-12" style="border-right: 1px solid #e0e0e0">
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-7 align-self-center">
                            <div v-if="reportDescription != ''" class="card">
                                <div class="card-body">
                                    <div class="card-text">
                                        {{ reportDescription }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <base-input label="Site Selection" class="col-md-6">
                            <a-select mode="multiple" style="width: 100%" placeholder="Please select" optionFilterProp="children"  v-model="selectedSiteId" :disabled="site_type != 'ho'">
                                <a-select-option v-for="site in validSites" :key="site.id" :value="site.id">{{site.name}}</a-select-option>
                            </a-select>
                        </base-input>

                        <base-input label="Report Format" class="col-md-6">
                            <a-select style="width: 100%" placeholder="Please select" v-model="selectedFormat">
                                <a-select-option  :key="1" :value="1">Default</a-select-option>
                                <a-select-option  :key="2" :value="2">Compact</a-select-option>
                            </a-select>
                        </base-input>

                        <base-input v-if="selectedFormat == 1" label="Date Range" class="col-md-6">
                            <br><a-range-picker @change="onDateFilter2" :allowClear="false" :format="dateFormat" input-classes="form-control" style="width: 100%"/>
                        </base-input>

                        <base-input v-if="selectedFormat == 2" label="Date Range" class="col-md-6">
                            <br>
                            <a-range-picker
                              :placeholder="['Start month', 'End month']"
                              format="YYYY-MM"
                              :value="value"
                              :mode="mode2"
                              :allowClear="false"
                              @panelChange="handlePanelChange2"
                              @change="onDateFilter3"
                            />
                            <!-- <a-range-picker :placeholder="['Start month', 'End month']" @panelChange="handlePanelChange2" @change="onDateFilter3" format="YYYY-MM" :mode="mode2" input-classes="form-control" style="width: 100%"/> -->
                        </base-input>

                        <!-- <base-input label="From" class="col-md-6">
                            <br><a-date-picker @change="onDateFilter2" :format="dateFormat" input-classes="form-control" style="width: 100%"/>
                        </base-input>      -->
                    </div>
                    <div class="row">
                        <div class="col-md-12">
                            <br>
                            <download-excel
                                v-if="selectedFormat == 1"
                                :fetch   = "fetchData"
                                :fields = "json_fields"
                                worksheet = "BIR Combined Reports"
                                name    = "bir_combined_reports.xls"
                                type = "xls">
                                <button class="btn btn-sm btn-success float-right ml-2" style="border-radius: 24px; border:0px; width: 20%;">Generate Report in Excel</button>
                            </download-excel>

                            <download-excel
                                v-if="selectedFormat == 2"
                                :fetch   = "fetchData"
                                :fields = "json_fields2"
                                :stringifyLongNum="true"
                                worksheet = "BIR Combined Reports"
                                name    = "bir_combined_reports_compact.xls"
                                type = "xls">
                                <button class="btn btn-sm btn-success float-right ml-2" style="border-radius: 24px; border:0px; width: 20%;">Generate Report in Excel</button>
                            </download-excel>

                            <button class="btn btn-sm btn-default float-right" style="border-radius: 24px; border:0px; width: 20%;" @click.prevent="generateReport">Generate Report in PDF</button> &nbsp; &nbsp;
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</a-spin>
</template>

<script>
    import HTTPRequest from '../../controllers/httpRequest.js'
    import secureStorage from '../../controllers/secureStorage';
    import moment from 'moment';
    import jsPDF from 'jspdf';
    import 'jspdf-autotable';
    import { getReportDescription } from '../../utilities';

    function formatNumber(num) {
        return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,')
    }

    const fs = require('fs')

    import {
        mapState
    } from 'vuex'

    export default {
        data() {
            return {
                spinning: false,
                value: [],
                mode2: ['month', 'month'],
                selectedFormat: 1,
                selectedSiteId: [],
                site_type: "ho",
                dateFormat: 'YYYY-MM-DD',
                validSites: null,
                dateFilter: null,
                searchDateFrom: null,
                searchDateTo: null,
                jsonData: [],
                json_fields2: {
                    "Terminal Name": "terminal_name",
                    "TIN": "site_tin",
                    "TIN Branch Code": "tin_branch_code",
                    "Branch": "site_name",
                    "Month": "month",
                    "Year": "year",
                    "MIN": "machine_no",
                    "Last OR": "last_or",
                    "Vatable Sales": "vatable_sales",
                    "VAT Zero Rated": "zero_rated_sales",
                    "VAT Exempt Sales": "vat_exempt_sales",
                    "Other Taxes": "other_taxes",
                    "VAT Amount": "vat_amount",
                    "NET Sales": "net_sales"
                },
                json_fields: {
                    'Machine No': 'machineNo',
                    'Terminal Code':  'terminaCode',
                    'Business Date':  'businessDate' ,
                    'Invoice Number (From)':  'beginningSi' ,
                    'Invoice Number (To)':  'endingSi' ,
                    'Beginning Balance': 'beginningBalance' ,
                    'Ending Balance': 'endingBalance' ,
                    'Gross Sales': 'grossSales' ,
                    'Vatable Sales': 'grossVatableSales' ,
                    'VAT Amount': 'grossVatAmount' ,
                    'VAT Exempt Sales': 'grossVatExemptSales' ,
                    'Zero Rated Sales': 'grossZeroRatedSales' ,
                    'Deductions (Regular Discount)': 'regularDiscount' ,
                    'Deductions (Special Discount - 5%)': 'specialDiscount' ,
                    'Deductions (Special Discount - 20%)': 'specialDiscount2' ,
                    'Deductions (Return)': 'totalReturns' ,
                    'Deductions (Void)': 'totalVoids' ,
                    'Deductions (Manual)': 'totalReplaced' ,
                    'Total Deductions': 'totalDeductions' ,
                    'Adjustments on VAT (Regular)': 'adjustmentOnVatRegular' ,
                    'Adjustments on VAT (Special - 5%)': 'adjustmentOnVatSpecial' ,
                    'Adjustments on VAT (Special - 20%)': 'adjustmentOnVatSpecial2' ,
                    'Adjustments on VAT (Return)': 'adjustmentOnVatReturns' ,
                    'Adjustments on VAT (Void)': 'adjustmentOnVatVoids' ,
                    'Adjustments on VAT (Manual)': 'adjustmentOnVatManual' ,
                    'Total Adjustments': 'totalVatAdjustments' ,
                    'VAT Payables': 'vatPayables' ,
                    'Net Amount Received': 'netAmountReceived' ,
                    'Other Income (Excess GC)': 'excessGC' ,
                    'Other Income (Excess RS)': 'excessRS' ,
                    'Sales Including Excess': 'salesWithExcess' ,
                    'Reset Counter': 'siResetCount' ,
                    'Z-Counter': 'zReadingCounter'
              },
              reportDescription: ''
            }
        },
        mounted: async function () {
            var userId = secureStorage.getItem("userId")
            var site_data = await HTTPRequest.getRequest(this.endPoint + 'sites/get_valid_sites?user_id=' + userId, null)
            this.validSites = site_data

            let siteId = secureStorage.getItem("defaultSiteId")
            this.selectedSiteId = [siteId]

            let site = await HTTPRequest.getRequest(this.endPoint + "/sites/" + siteId, null)
            if(site != undefined){
                this.site_type = site.site_type
            }
            this.reportDescription = await getReportDescription(this.currentProfile)
        },
        computed: {
            ...mapState(['currentProfile', 'currentApiURL', 'endPoint', 'parameters']),
        },
        methods: {
            moment,
            onDateFilter2(date, dateString) {
                this.searchDateFrom = dateString[0]
                this.searchDateTo = dateString[1]
            },
            onDateFilter3(value) {
                this.value = value;
            },
            handlePanelChange2(value, mode) {
              this.value = value;
              this.mode2 = [mode[0] === 'date' ? 'month' : mode[0], mode[1] === 'date' ? 'month' : mode[1]];
            },
            async fetchData(){
                this.spinning= true;
                if(this.selectedFormat == 2){
                  if (!this.value[0] || !this.value[1]) {
                    this.$notification['error']({
                      message: 'Export Error',
                      description: "Date Range can't be blank. Try increasing the scope by adjusting the filters."
                    });
                    this.spinning= false;
                    return [];
                  } else {
                    this.searchDateFrom = this.value[0] ? this.value[0].startOf('month').format("YYYY-MM-DD") : '';
                    this.searchDateTo = this.value[1] ? this.value[1].endOf('month').format("YYYY-MM-DD") : '';
                  }
                }

                this.jsonData =[];
                var queryResult = await HTTPRequest.getRequest(this.endPoint + `z_readings/bir_combined_report?format=${this.selectedFormat}&from=` + this.searchDateFrom + "&to=" + this.searchDateTo + "&site_ids=" + this.selectedSiteId , null)
                // var queryResult = await HTTPRequest.getRequest(this.endPoint + 'z_readings/bir_combined_report?from=' + this.dateFilter + "&site_ids=" + this.selectedSiteId , null)
                var siteSpecific = queryResult.report_details

                let reportLengths = siteSpecific.map(a => a.report_details.length)
                console.log("reportLengths")
                console.log(reportLengths)
                let isReportsEmpty = reportLengths.every(reportLength => reportLength == 0)
                console.log("checker")
                console.log(isReportsEmpty)
                if (isReportsEmpty) {
                    this.$notification['warning']({
                    message: 'Export Error',
                    description: 'Empty data. Try increasing the scope by adjusting the filters.'
                    });
                    this.spinning= false;
                    return [];
                }
                
                // var combinedData = []
                if(this.selectedFormat == 1){
                    var siteTotalSales = 0 ,siteTotalVatablesSales = 0 ,siteTotalVatAmount = 0 ,siteTotalVatExemptSales = 0 ,siteTotalZeroRatedSales = 0 ,siteTotalRegularDeductions = 0 ,siteTotalSpecialDeductions = 0 ,siteTotalReturnDeductions = 0 ,siteTotalVoidDeductions = 0 ,siteTotalManualDeductions = 0 ,siteTotalDeductions2 = 0 ,siteTotalVatAdjustmentRegular = 0 ,siteTotalVatAdjustmentSpecial = 0 ,siteTotalVatAdjustmentReturn = 0 ,siteTotalVatAdjustmentVoid = 0 ,siteTotalVatAdjustmentManual = 0 ,siteTotalAdjustment2 = 0 ,siteTotalVatPayables = 0 ,siteTotalNetAmountReceived = 0 ,siteTotalExcessGC = 0 ,siteTotalExcessRS = 0 ,siteTotalSalesIncludingExcess= 0, siteTotalVatAdjustmentSpecial2= 0, siteTotalSpecialDeductions2 = 0;
                    for(var x=0; x < siteSpecific.length; x++){
                        this.birCombinedReports = siteSpecific[x].report_details
                        // console.log("")

                        // if(this.birCombinedReports.length > 0){
                        var reportData = [];
                        var totalSales =0, totalVatablesSales =0, totalVatAmount =0, totalVatExemptSales =0, totalZeroRatedSales =0, totalRegularDeductions =0, totalSpecialDeductions =0, totalSpecialDeductions2 = 0,
                            totalReturnDeductions =0, totalVoidDeductions =0, totalManualDeductions =0, totalDeductions2 =0, totalVatAdjustmentRegular =0,
                            totalVatAdjustmentSpecial =0,totalVatAdjustmentSpecial2 =0,  totalVatAdjustmentReturn =0, totalVatAdjustmentVoid =0, totalVatAdjustmentManual =0, totalAdjustment2 =0,
                            totalVatPayables =0, totalNetAmountReceived =0, totalExcessGC =0, totalExcessRS =0, totalSalesIncludingExcess=0;

                            
                        for(var i=0; i < this.birCombinedReports.length; i++){

                                var reportLine = this.birCombinedReports[i]
                                var reportLineDetails = JSON.parse(reportLine.reading_details)
                                // var reportLineDetails = JSON.parse(JSON.parse(reportLine.reading_details))

                                var vatPayables = reportLineDetails.grossSales.vatAmount - reportLineDetails.adjustmentsOnVat.total
                                // var netAmountReceived = reportLineDetails.grossSales.total - (reportLineDetails.deductions.total + reportLineDetails.adjustmentsOnVat.total)
                                var netAmountReceived = reportLineDetails.netSales
                                var salesWithExcess = netAmountReceived + reportLineDetails.otherIncome.total
                                // var vat_exempt_sales = (parseFloat(reportLineDetails.netSalesBreakdown.vatExempt.toFixed(2)) > 0) ? reportLineDetails.netSalesBreakdown.vatExempt.toFixed(2) : reportLineDetails.grossSales.vatExempt.toFixed(2)
                                var vat_exempt_sales = parseFloat(reportLineDetails.grossSales.vatExempt.toFixed(2))

                                // grossSales
                                totalSales  += parseFloat( reportLineDetails.grossSales.total.toFixed(2) )
                                totalVatablesSales  += parseFloat( reportLineDetails.grossSales.vatable.toFixed(2) )
                                totalVatAmount  += parseFloat( reportLineDetails.grossSales.vatAmount.toFixed(2) )
                                totalVatExemptSales  += parseFloat( vat_exempt_sales )
                                totalZeroRatedSales  += parseFloat( reportLineDetails.grossSales.zeroRated.toFixed(2) )

                                // deductions
                                totalRegularDeductions  += parseFloat( reportLineDetails.deductions.regular.toFixed(2) )
                                totalSpecialDeductions2  += parseFloat( reportLineDetails.deductions.specialVatExemptDiscount.toFixed(2) )
                                totalSpecialDeductions  += parseFloat( reportLineDetails.deductions.specialVatableDiscount.toFixed(2) )
                                totalReturnDeductions  += parseFloat( reportLineDetails.deductions.returns.toFixed(2) ) + parseFloat( (reportLineDetails.deductions.refund || 0).toFixed(2) )
                                totalVoidDeductions  += parseFloat( reportLineDetails.deductions.void.toFixed(2) )
                                totalManualDeductions  += parseFloat( reportLineDetails.deductions.manual.toFixed(2) )
                                totalDeductions2  += parseFloat( reportLineDetails.deductions.total.toFixed(2) )

                                // adjustmentsOnVat
                                totalVatAdjustmentRegular  += parseFloat( reportLineDetails.adjustmentsOnVat.regular.toFixed(2) )
                                totalVatAdjustmentSpecial2  += parseFloat( reportLineDetails.adjustmentsOnVat.specialVatExemptDiscount.toFixed(2) )
                                totalVatAdjustmentSpecial  += parseFloat( reportLineDetails.adjustmentsOnVat.specialVatableDiscount.toFixed(2) )
                                totalVatAdjustmentReturn  += parseFloat( reportLineDetails.adjustmentsOnVat.returns.toFixed(2) ) + parseFloat( (reportLineDetails.adjustmentsOnVat.refund || 0).toFixed(2) )
                                totalVatAdjustmentVoid  += parseFloat( reportLineDetails.adjustmentsOnVat.void.toFixed(2) )
                                totalVatAdjustmentManual  += parseFloat( reportLineDetails.adjustmentsOnVat.manual.toFixed(2) )
                                totalAdjustment2  += parseFloat( reportLineDetails.adjustmentsOnVat.total.toFixed(2) )


                                totalVatPayables  += parseFloat( vatPayables.toFixed(2))
                                totalNetAmountReceived  += parseFloat( netAmountReceived.toFixed(2) )

                                // otherIncome
                                totalExcessGC  += parseFloat( reportLineDetails.otherIncome.excessGC.toFixed(2) )
                                totalExcessRS  += parseFloat( reportLineDetails.otherIncome.excessRS.toFixed(2) )
                                totalSalesIncludingExcess += parseFloat( salesWithExcess.toFixed(2) )

                                var detail_hash = {
                                    machineNo: `'${reportLine.machine_no}`,
                                    terminaCode: reportLine.name,
                                    businessDate:  moment(reportLine.business_date).format("MM-DD-YYYY"),
                                    beginningSi: reportLineDetails.beginningSi,
                                    endingSi: reportLineDetails.endingSi,
                                    beginningBalance: reportLineDetails.beginningBalance.toFixed(2),
                                    endingBalance: reportLineDetails.endingBalance.toFixed(2),

                                    grossSales: reportLineDetails.grossSales.total.toFixed(2),
                                    grossVatableSales: reportLineDetails.grossSales.vatable.toFixed(2),
                                    grossVatAmount: reportLineDetails.grossSales.vatAmount.toFixed(2),
                                    grossVatExemptSales: vat_exempt_sales,
                                    grossZeroRatedSales: reportLineDetails.grossSales.zeroRated.toFixed(2),

                                    regularDiscount: reportLineDetails.deductions.regular.toFixed(2),
                                    specialDiscount2: reportLineDetails.deductions.specialVatExemptDiscount.toFixed(2) ,
                                    specialDiscount: reportLineDetails.deductions.specialVatableDiscount.toFixed(2) ,
                                    totalReturns: (parseFloat(reportLineDetails.deductions.returns.toFixed(2)) + parseFloat((reportLineDetails.deductions.refund || 0).toFixed(2))).toFixed(2),
                                    totalVoids: reportLineDetails.deductions.void.toFixed(2),
                                    totalReplaced: reportLineDetails.deductions.manual.toFixed(2),
                                    totalDeductions: reportLineDetails.deductions.total.toFixed(2),

                                    adjustmentOnVatRegular: reportLineDetails.adjustmentsOnVat.regular.toFixed(2),
                                    adjustmentOnVatSpecial2: reportLineDetails.adjustmentsOnVat.specialVatExemptDiscount.toFixed(2),
                                    adjustmentOnVatSpecial: reportLineDetails.adjustmentsOnVat.specialVatableDiscount.toFixed(2),
                                    adjustmentOnVatReturns: (parseFloat(reportLineDetails.adjustmentsOnVat.returns.toFixed(2)) + parseFloat((reportLineDetails.adjustmentsOnVat.refund || 0).toFixed(2))).toFixed(2),
                                    adjustmentOnVatVoids: reportLineDetails.adjustmentsOnVat.void.toFixed(2),
                                    adjustmentOnVatManual: reportLineDetails.adjustmentsOnVat.manual.toFixed(2),
                                    totalVatAdjustments: reportLineDetails.adjustmentsOnVat.total.toFixed(2),

                                    vatPayables: vatPayables.toFixed(2),
                                    netAmountReceived: netAmountReceived.toFixed(2),
                                    excessGC: reportLineDetails.otherIncome.excessGC.toFixed(2),
                                    excessRS: reportLineDetails.otherIncome.excessRS.toFixed(2),
                                    salesWithExcess: salesWithExcess.toFixed(2),
                                    siResetCount: reportLineDetails.siResetCount,
                                    zReadingCounter: reportLineDetails.zReadingCounter
                                }

                                this.jsonData.push(detail_hash)
                        }

                        if (this.jsonData.length == 0) {
                          continue
                        }

                        siteTotalSales += totalSales
                        siteTotalVatablesSales += totalVatablesSales
                        siteTotalVatAmount += totalVatAmount
                        siteTotalVatExemptSales += totalVatExemptSales
                        siteTotalZeroRatedSales += totalZeroRatedSales
                        siteTotalRegularDeductions += totalRegularDeductions
                        siteTotalSpecialDeductions += totalSpecialDeductions
                        siteTotalSpecialDeductions2 += totalSpecialDeductions2
                        siteTotalReturnDeductions += totalReturnDeductions
                        siteTotalVoidDeductions += totalVoidDeductions
                        siteTotalManualDeductions += totalManualDeductions
                        siteTotalDeductions2 += totalDeductions2
                        siteTotalVatAdjustmentRegular += totalVatAdjustmentRegular
                        siteTotalVatAdjustmentSpecial += totalVatAdjustmentSpecial
                        siteTotalVatAdjustmentSpecial2 += totalVatAdjustmentSpecial2
                        siteTotalVatAdjustmentReturn += totalVatAdjustmentReturn
                        siteTotalVatAdjustmentVoid += totalVatAdjustmentVoid
                        siteTotalVatAdjustmentManual += totalVatAdjustmentManual
                        siteTotalAdjustment2 += totalAdjustment2
                        siteTotalVatPayables += totalVatPayables
                        siteTotalNetAmountReceived += totalNetAmountReceived
                        siteTotalExcessGC += totalExcessGC
                        siteTotalExcessRS += totalExcessRS
                        siteTotalSalesIncludingExcess+= totalSalesIncludingExcess

                        if(this.birCombinedReports.length > 0)
                            this.jsonData.push({machineNo : "SITE TOTAL:" , terminalCode: "" , businessDate : "" , beginningSi : "" , endingSi : "" , beginningBalance : "" , endingBalance : "" , grossSales : totalSales.toFixed(2) , grossVatableSales : totalVatablesSales.toFixed(2) , grossVatAmount : totalVatAmount.toFixed(2) , grossVatExemptSales : totalVatExemptSales.toFixed(2) , grossZeroRatedSales : totalZeroRatedSales.toFixed(2) , regularDiscount : totalRegularDeductions.toFixed(2) , specialDiscount2 : totalSpecialDeductions2.toFixed(2) , specialDiscount : totalSpecialDeductions.toFixed(2),  totalReturns : totalReturnDeductions.toFixed(2) , totalVoids : totalVoidDeductions.toFixed(2) , totalReplaced : totalManualDeductions.toFixed(2) , totalDeductions : totalDeductions2.toFixed(2) , adjustmentOnVatRegular : totalVatAdjustmentRegular.toFixed(2) , adjustmentOnVatSpecial2 : totalVatAdjustmentSpecial2.toFixed(2), adjustmentOnVatSpecial : totalVatAdjustmentSpecial.toFixed(2) , adjustmentOnVatReturns : totalVatAdjustmentReturn.toFixed(2) , adjustmentOnVatVoids : totalVatAdjustmentVoid.toFixed(2) , adjustmentOnVatManual : totalVatAdjustmentManual.toFixed(2) , totalVatAdjustments : totalAdjustment2.toFixed(2) , vatPayables : totalVatPayables.toFixed(2) , netAmountReceived : totalNetAmountReceived.toFixed(2) , excessGC : totalExcessGC.toFixed(2) , excessRS : totalExcessRS.toFixed(2) , salesWithExcess : totalSalesIncludingExcess.toFixed(2) , siResetCount : "", zReadingCounter : ""})

                        if(x == (siteSpecific.length - 1)){
                            this.jsonData.push({
                                machineNo : "GRAND TOTAL: " ,
                                terminaCode: "",
                                businessDate : "",
                                beginningSi : "",
                                endingSi : "",
                                beginningBalance : "",
                                endingBalance : "",
                                grossSales : siteTotalSales.toFixed(2) ,
                                grossVatableSales : siteTotalVatablesSales.toFixed(2) ,
                                grossVatAmount : siteTotalVatAmount.toFixed(2) ,
                                grossVatExemptSales : siteTotalVatExemptSales.toFixed(2) ,
                                grossZeroRatedSales : siteTotalZeroRatedSales.toFixed(2) ,
                                regularDiscount : siteTotalRegularDeductions.toFixed(2) ,
                                specialDiscount : siteTotalSpecialDeductions.toFixed(2) ,
                                specialDiscount2 : siteTotalSpecialDeductions2.toFixed(2) ,
                                totalReturns : siteTotalReturnDeductions.toFixed(2) ,
                                totalVoids : siteTotalVoidDeductions.toFixed(2) ,
                                totalReplaced : siteTotalManualDeductions.toFixed(2) ,
                                totalDeductions : siteTotalDeductions2.toFixed(2) ,
                                adjustmentOnVatRegular : siteTotalVatAdjustmentRegular.toFixed(2) ,
                                adjustmentOnVatSpecial : siteTotalVatAdjustmentSpecial.toFixed(2) ,
                                adjustmentOnVatSpecial2 : siteTotalVatAdjustmentSpecial2.toFixed(2) ,
                                adjustmentOnVatReturns : siteTotalVatAdjustmentReturn.toFixed(2) ,
                                adjustmentOnVatVoids : siteTotalVatAdjustmentVoid.toFixed(2) ,
                                adjustmentOnVatManual : siteTotalVatAdjustmentManual.toFixed(2) ,
                                totalVatAdjustments : siteTotalAdjustment2.toFixed(2) ,
                                vatPayables : siteTotalVatPayables.toFixed(2) ,
                                netAmountReceived : siteTotalNetAmountReceived.toFixed(2) ,
                                excessGC : siteTotalExcessGC.toFixed(2) ,
                                excessRS : siteTotalExcessRS.toFixed(2) ,
                                salesWithExcess : siteTotalSalesIncludingExcess.toFixed(2),
                                siResetCount : "",
                                zReadingCounter : ""
                            })
                        }

                        }
                    this.spinning= false;
                    return this.jsonData;
                }else{
                    for(var x=0; x < siteSpecific.length; x++){
                        this.birCombinedReports = siteSpecific[x].report_details

                        // console.log("____!!!!_______")
                        // console.log(this.birCombinedReports)

                        for(var i=0; i < this.birCombinedReports.length; i++){
                            var reportData = this.birCombinedReports[i];
                            reportData.machine_no = `'${reportData.machine_no}`
                            reportData.site_tin = `'${siteSpecific[x].site_tin}`
                            reportData.tin_branch_code = `'${siteSpecific[x].tin_branch_code}`
                            reportData.site_name = siteSpecific[x].site_name
                            this.jsonData.push(reportData)
                        }
                    }
                    this.spinning= false;
                    return this.jsonData;
                }
            },
            async generateReport(){
                // 2021-03-03
                this.spinning= true;
                if(this.selectedFormat == 2){if (!this.value[0] || !this.value[1]) {
                    this.$notification['error']({
                      message: 'Export Error',
                      description: "Date Range can't be blank. Try increasing the scope by adjusting the filters."
                    });
                    this.spinning= false;
                    return [];
                  } else {
                    this.searchDateFrom = this.value[0] ? this.value[0].startOf('month').format("YYYY-MM-DD") : '';
                    this.searchDateTo = this.value[1] ? this.value[1].endOf('month').format("YYYY-MM-DD") : '';
                    if(this.searchDateFrom == null || this.searchDateTo == null){
                        this.$notification['error']({
                        message: 'Export Error',
                        description: "Date Range can't be blank. Try increasing the scope by adjusting the filters."
                        });
                        this.spinning= false;
                        return [];
                    }
                  }
                } else {
                    if(this.searchDateFrom == null || this.searchDateTo == null){
                        this.$notification['error']({
                        message: 'Export Error',
                        description: "Date Range can't be blank. Try increasing the scope by adjusting the filters."
                        });
                        this.spinning= false;
                        return [];
                    }
                }

                var queryResult = await HTTPRequest.getRequest(this.endPoint + `z_readings/bir_combined_report?format=${this.selectedFormat}&from=` + this.searchDateFrom + "&to=" + this.searchDateTo + "&site_ids=" + this.selectedSiteId , null)

                let reportLengths = queryResult.report_details.map(a => a.report_details.length)
                console.log("reportLengths")
                console.log(reportLengths)
                let isReportsEmpty = reportLengths.every(reportLength => reportLength == 0)
                console.log("checker")
                console.log(isReportsEmpty)
                if (isReportsEmpty) {
                    this.$notification['warning']({
                    message: 'Export Error',
                    description: 'Empty data. Try increasing the scope by adjusting the filters.'
                    });
                    this.spinning= false;
                    return [];
                }
                
                if(this.selectedFormat == 1){
                    var siteSpecific = queryResult.report_details
                    var headers = [     [
                                     {content: 'Machine No', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Terminal Code', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Date', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Invoice Number', rowSpan: 2, colSpan: 2, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Beginning Balance', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Ending Balance', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Gross Sales', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Vatable Sales', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'VAT Amount', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Vat-Exempt Sales', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Zero Rated Sales', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Deductions', colSpan: 7, styles: {halign: 'center'}},
                                     {content: 'Adjustments on VAT', colSpan: 7, styles: {halign: 'center'}},
                                     {content: 'VAT Payables', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Net Amount Received', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Other Income', rowSpan: 2, colSpan: 2, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Sales Including Excess', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Reset Counter', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                     {content: 'Z-Counter', rowSpan: 3, styles: {halign: 'center', valign: 'center'}},
                                    ],
                                    [{content: 'Discounts', colSpan: 3, styles: {halign: 'center'}}, {content: 'Return', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}, {content: 'Void', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}, {content: 'Manual', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}, {content: 'Total Deductions', rowSpan: 2, styles: {halign: 'center', valign: 'center'}},{content: 'Regular', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}, {content: 'Special (5%)', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}, {content: 'Special (20%)', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}, {content: 'Return', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}, {content: 'Void', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}, {content: 'Manual', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}, {content: 'Total Adjustments', rowSpan: 2, styles: {halign: 'center', valign: 'center'}}],
                                    ["From", "To", "Regular", "Special (5%)", "Special (10%)", "Excess GC", "Excess RS"]
                              ];

                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: [615, 1770] });

                    let reportLogo = document.getElementById('reportLogo');
                    doc.addImage(reportLogo, "PNG", 15, 0, 15, 15);

                    var siteTotalSales = 0 ,siteTotalVatablesSales = 0 ,siteTotalVatAmount = 0 ,siteTotalVatExemptSales = 0 ,siteTotalZeroRatedSales = 0 ,siteTotalRegularDeductions = 0 ,siteTotalSpecialDeductions = 0 ,siteTotalReturnDeductions = 0 ,siteTotalVoidDeductions = 0 ,siteTotalManualDeductions = 0 ,siteTotalDeductions2 = 0 ,siteTotalVatAdjustmentRegular = 0 ,siteTotalVatAdjustmentSpecial = 0 ,siteTotalVatAdjustmentReturn = 0 ,siteTotalVatAdjustmentVoid = 0 ,siteTotalVatAdjustmentManual = 0 ,siteTotalAdjustment2 = 0 ,siteTotalVatPayables = 0 ,siteTotalNetAmountReceived = 0 ,siteTotalExcessGC = 0 ,siteTotalExcessRS = 0 ,siteTotalSalesIncludingExcess= 0, siteTotalVatAdjustmentSpecial2= 0, siteTotalSpecialDeductions2 = 0;

                    for(var x=0; x < siteSpecific.length; x++){
                        this.birCombinedReports = siteSpecific[x].report_details

                        if(x > 0 ){
                            doc.addPage();
                        }

                        var reportData = [];
                        var totalSales =0, totalVatablesSales =0, totalVatAmount =0, totalVatExemptSales =0, totalZeroRatedSales =0, totalRegularDeductions =0, totalSpecialDeductions =0, totalSpecialDeductions2 = 0,
                            totalReturnDeductions =0, totalVoidDeductions =0, totalManualDeductions =0, totalDeductions2 =0, totalVatAdjustmentRegular =0,
                            totalVatAdjustmentSpecial =0,totalVatAdjustmentSpecial2 =0,  totalVatAdjustmentReturn =0, totalVatAdjustmentVoid =0, totalVatAdjustmentManual =0, totalAdjustment2 =0,
                            totalVatPayables =0, totalNetAmountReceived =0, totalExcessGC =0, totalExcessRS =0, totalSalesIncludingExcess=0;

                        for(var i=0; i < this.birCombinedReports.length; i++){
                                var reportLine = this.birCombinedReports[i]
                                var reportLineDetails = JSON.parse(reportLine.reading_details)

                                var vatPayables = reportLineDetails.grossSales.vatAmount - reportLineDetails.adjustmentsOnVat.total
                                // var netAmountReceived = reportLineDetails.grossSales.total - (reportLineDetails.deductions.total + reportLineDetails.adjustmentsOnVat.total)
                                var netAmountReceived = reportLineDetails.netSales
                                var salesWithExcess = netAmountReceived + reportLineDetails.otherIncome.total

                                // var vat_exempt_sales = (parseFloat(reportLineDetails.netSalesBreakdown.vatExempt.toFixed(2)) > 0) ? reportLineDetails.netSalesBreakdown.vatExempt.toFixed(2) : reportLineDetails.grossSales.vatExempt.toFixed(2)
                                 var vat_exempt_sales = reportLineDetails.grossSales.vatExempt.toFixed(2)

                                // grossSales
                                totalSales  += parseFloat( reportLineDetails.grossSales.total.toFixed(2) )
                                totalVatablesSales  += parseFloat( reportLineDetails.grossSales.vatable.toFixed(2) )
                                totalVatAmount  += parseFloat( reportLineDetails.grossSales.vatAmount.toFixed(2) )
                                totalVatExemptSales  += parseFloat( vat_exempt_sales )
                                totalZeroRatedSales  += parseFloat( reportLineDetails.grossSales.zeroRated.toFixed(2) )

                                // deductions
                                totalRegularDeductions  += parseFloat( reportLineDetails.deductions.regular.toFixed(2) )
                                totalSpecialDeductions  += parseFloat( reportLineDetails.deductions.specialVatableDiscount.toFixed(2) )
                                totalSpecialDeductions2  += parseFloat( reportLineDetails.deductions.specialVatExemptDiscount.toFixed(2) )
                                totalReturnDeductions  += parseFloat( reportLineDetails.deductions.returns.toFixed(2) ) + parseFloat( (reportLineDetails.deductions.refund || 0).toFixed(2) )
                                totalVoidDeductions  += parseFloat( reportLineDetails.deductions.void.toFixed(2) )
                                totalManualDeductions  += parseFloat( reportLineDetails.deductions.manual.toFixed(2) )
                                totalDeductions2  += parseFloat( reportLineDetails.deductions.total.toFixed(2) )

                                // adjustmentsOnVat
                                totalVatAdjustmentRegular  += parseFloat( reportLineDetails.adjustmentsOnVat.regular.toFixed(2) )
                                totalVatAdjustmentSpecial  += parseFloat( reportLineDetails.adjustmentsOnVat.specialVatableDiscount.toFixed(2) )
                                totalVatAdjustmentSpecial2  += parseFloat( reportLineDetails.adjustmentsOnVat.specialVatExemptDiscount.toFixed(2) )
                                totalVatAdjustmentReturn  += parseFloat( reportLineDetails.adjustmentsOnVat.returns.toFixed(2) ) + parseFloat( (reportLineDetails.adjustmentsOnVat.refund || 0).toFixed(2) )
                                totalVatAdjustmentVoid  += parseFloat( reportLineDetails.adjustmentsOnVat.void.toFixed(2) )
                                totalVatAdjustmentManual  += parseFloat( reportLineDetails.adjustmentsOnVat.manual.toFixed(2) )
                                totalAdjustment2  += parseFloat( reportLineDetails.adjustmentsOnVat.total.toFixed(2) )


                                totalVatPayables  += parseFloat( vatPayables.toFixed(2))
                                totalNetAmountReceived  += parseFloat( netAmountReceived.toFixed(2) )

                                // otherIncome
                                totalExcessGC  += parseFloat( reportLineDetails.otherIncome.excessGC.toFixed(2) )
                                totalExcessRS  += parseFloat( reportLineDetails.otherIncome.excessRS.toFixed(2) )
                                totalSalesIncludingExcess += parseFloat( salesWithExcess.toFixed(2) )

                                var detail = [
                                       reportLine.machine_no, reportLine.name,
                                       moment(reportLine.business_date).format("MM-DD-YYYY"),
                                       reportLineDetails.beginningSi, reportLineDetails.endingSi,
                                       formatNumber(reportLineDetails.beginningBalance.toFixed(2)),
                                       formatNumber(reportLineDetails.endingBalance.toFixed(2)),

                                       // grossSales
                                       formatNumber(reportLineDetails.grossSales.total.toFixed(2)),
                                       formatNumber(reportLineDetails.grossSales.vatable.toFixed(2)),
                                       formatNumber(reportLineDetails.grossSales.vatAmount.toFixed(2)),
                                       formatNumber(vat_exempt_sales),
                                       formatNumber(reportLineDetails.grossSales.zeroRated.toFixed(2)),

                                       // deductions
                                       formatNumber(reportLineDetails.deductions.regular.toFixed(2)),
                                       formatNumber(reportLineDetails.deductions.specialVatableDiscount.toFixed(2)),
                                       formatNumber(reportLineDetails.deductions.specialVatExemptDiscount.toFixed(2)),
                                       formatNumber((parseFloat(reportLineDetails.deductions.returns.toFixed(2)) + parseFloat((reportLineDetails.deductions.refund || 0).toFixed(2))).toFixed(2)),
                                       formatNumber(reportLineDetails.deductions.void.toFixed(2)),
                                       formatNumber(reportLineDetails.deductions.manual.toFixed(2)),
                                       formatNumber(reportLineDetails.deductions.total.toFixed(2)),

                                       // adjustmentsOnVat
                                       formatNumber(reportLineDetails.adjustmentsOnVat.regular.toFixed(2)),
                                       formatNumber(reportLineDetails.adjustmentsOnVat.specialVatableDiscount.toFixed(2)),
                                       formatNumber(reportLineDetails.adjustmentsOnVat.specialVatExemptDiscount.toFixed(2)),
                                       formatNumber((parseFloat(reportLineDetails.adjustmentsOnVat.returns.toFixed(2)) + parseFloat((reportLineDetails.adjustmentsOnVat.refund || 0).toFixed(2))).toFixed(2)),
                                       formatNumber(reportLineDetails.adjustmentsOnVat.void.toFixed(2)),
                                       formatNumber(reportLineDetails.adjustmentsOnVat.manual.toFixed(2)),
                                       formatNumber(reportLineDetails.adjustmentsOnVat.total.toFixed(2)),

                                       // !!!! Unknown
                                       formatNumber(vatPayables.toFixed(2)),
                                       formatNumber(netAmountReceived.toFixed(2)),

                                       // otherIncome
                                       formatNumber(reportLineDetails.otherIncome.excessGC.toFixed(2)),
                                       formatNumber(reportLineDetails.otherIncome.excessRS.toFixed(2)),


                                       formatNumber(salesWithExcess.toFixed(2)),
                                       reportLineDetails.siResetCount,
                                       reportLineDetails.zReadingCounter
                                    ]
                                reportData.push(Object.assign({}, detail))
                        }

                        if (reportData.length == 0) {
                            var pageCount = doc.internal.getNumberOfPages();
                            doc.deletePage(pageCount)
                            continue;
                        }

                        siteTotalSales += totalSales
                        siteTotalVatablesSales += totalVatablesSales
                        siteTotalVatAmount += totalVatAmount
                        siteTotalVatExemptSales += totalVatExemptSales
                        siteTotalZeroRatedSales += totalZeroRatedSales
                        siteTotalRegularDeductions += totalRegularDeductions
                        siteTotalSpecialDeductions += totalSpecialDeductions
                        siteTotalSpecialDeductions2 += totalSpecialDeductions2
                        siteTotalReturnDeductions += totalReturnDeductions
                        siteTotalVoidDeductions += totalVoidDeductions
                        siteTotalManualDeductions += totalManualDeductions
                        siteTotalDeductions2 += totalDeductions2
                        siteTotalVatAdjustmentRegular += totalVatAdjustmentRegular
                        siteTotalVatAdjustmentSpecial += totalVatAdjustmentSpecial
                        siteTotalVatAdjustmentSpecial2 += totalVatAdjustmentSpecial2
                        siteTotalVatAdjustmentReturn += totalVatAdjustmentReturn
                        siteTotalVatAdjustmentVoid += totalVatAdjustmentVoid
                        siteTotalVatAdjustmentManual += totalVatAdjustmentManual
                        siteTotalAdjustment2 += totalAdjustment2
                        siteTotalVatPayables += totalVatPayables
                        siteTotalNetAmountReceived += totalNetAmountReceived
                        siteTotalExcessGC += totalExcessGC
                        siteTotalExcessRS += totalExcessRS
                        siteTotalSalesIncludingExcess+= totalSalesIncludingExcess

                        reportData.push(Object.assign({}, ["SITETOTAL: ", "", "", "", "", "", "", formatNumber(totalSales.toFixed(2)), formatNumber(totalVatablesSales.toFixed(2)), formatNumber(totalVatAmount.toFixed(2)), formatNumber(totalVatExemptSales.toFixed(2)), formatNumber(totalZeroRatedSales.toFixed(2)), formatNumber(totalRegularDeductions.toFixed(2)), formatNumber(totalSpecialDeductions.toFixed(2)), formatNumber(totalSpecialDeductions2.toFixed(2)), formatNumber(totalReturnDeductions.toFixed(2)), formatNumber(totalVoidDeductions.toFixed(2)), formatNumber(totalManualDeductions.toFixed(2)), formatNumber(totalDeductions2.toFixed(2)), formatNumber(totalVatAdjustmentRegular.toFixed(2)), formatNumber(totalVatAdjustmentSpecial.toFixed(2)), formatNumber(totalVatAdjustmentSpecial2.toFixed(2)), formatNumber(totalVatAdjustmentReturn.toFixed(2)), formatNumber(totalVatAdjustmentVoid.toFixed(2)), formatNumber(totalVatAdjustmentManual.toFixed(2)), formatNumber(totalAdjustment2.toFixed(2)), formatNumber(totalVatPayables.toFixed(2)), formatNumber(totalNetAmountReceived.toFixed(2)), formatNumber(totalExcessGC.toFixed(2)), formatNumber(totalExcessRS.toFixed(2)), formatNumber(totalSalesIncludingExcess.toFixed(2)), "", ""]))

                        if(x == (siteSpecific.length - 1)){
                            reportData.push(Object.assign({}, ["GRAND TOTAL: ", "", "", "", "", "", "", formatNumber(siteTotalSales.toFixed(2)), formatNumber(siteTotalVatablesSales.toFixed(2)), formatNumber(siteTotalVatAmount.toFixed(2)), formatNumber(siteTotalVatExemptSales.toFixed(2)), formatNumber(siteTotalZeroRatedSales.toFixed(2)), formatNumber(siteTotalRegularDeductions.toFixed(2)), formatNumber(siteTotalSpecialDeductions.toFixed(2)), formatNumber(siteTotalSpecialDeductions2.toFixed(2)), formatNumber(siteTotalReturnDeductions.toFixed(2)), formatNumber(siteTotalVoidDeductions.toFixed(2)), formatNumber(siteTotalManualDeductions.toFixed(2)), formatNumber(siteTotalDeductions2.toFixed(2)), formatNumber(siteTotalVatAdjustmentRegular.toFixed(2)), formatNumber(siteTotalVatAdjustmentSpecial.toFixed(2)), formatNumber(siteTotalVatAdjustmentSpecial2.toFixed(2)), formatNumber(siteTotalVatAdjustmentReturn.toFixed(2)), formatNumber(siteTotalVatAdjustmentVoid.toFixed(2)), formatNumber(siteTotalVatAdjustmentManual.toFixed(2)), formatNumber(siteTotalAdjustment2.toFixed(2)), formatNumber(siteTotalVatPayables.toFixed(2)), formatNumber(siteTotalNetAmountReceived.toFixed(2)), formatNumber(siteTotalExcessGC.toFixed(2)), formatNumber(siteTotalExcessRS.toFixed(2)), formatNumber(siteTotalSalesIncludingExcess.toFixed(2)), "", ""]))
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"BIR Consolidated Report")
                        doc.setFontSize(12);
                        doc.text(15,25, siteSpecific[x].site_company)
                        doc.text(15,30, `'${siteSpecific[x].site_tin}'`)

                        let address = ''
                        if(siteSpecific[x].site_address != null){
                            address = siteSpecific[x].site_address
                        }
                        doc.text(15,35, address)

                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        // doc.text(15,30,"Company: " + siteSpecific[x].site_company)
                        // doc.text(15,35,"TIN: " + siteSpecific[x].site_tin)
                        // doc.text(15,45,"Address: " + siteSpecific[x].site_address)
                        doc.text(15,45,"Software: Barter POS Version 5.0")
                        doc.text(15,50,"Branch: " + siteSpecific[x].site_name)

                        if( this.searchDateFrom == this.searchDateTo){
                                doc.text(15,55,"Date: " +  moment(this.searchDateFrom).format(this.dateFormat) )
                        } else {
                            doc.text(15,55,"Date Range: From " + moment(this.searchDateFrom).format(this.dateFormat)  + " to " + moment(this.searchDateTo).format(this.dateFormat))
                        }

                        doc.autoTable(
                            {
                                startY: 60,
                                head: headers,
                                body: reportData,
                                theme: 'plain',
                                tableWidth: 'wrap',
                                styles: {
                                    cellPadding: 0.5, fontSize: 7,
                                    lineWidth: 0.05,
                                    halign: 'right'
                                },
                                headStyles: {
                                    lineWidth: 0.05,
                                    cellPadding: 2
                                },
                                columnStyles: {
                                    0: {halign: "center"},
                                    1: {halign: "center"},
                                    2: {halign: "center"},
                                    3: {halign: "center"},
                                    28: {halign: "center"},
                                    29: {halign: "center"},
                                }
                            }
                        );

                        doc.setFontSize(8);
                        doc.text(15,230,"Printed By: " + secureStorage.getItem("email"))
                        doc.text(600,230,"BIR Consolidated Report", "right")
                        doc.text(15,235,"Print Date: " + moment().format(this.dateFormat2))
                        doc.text(600,235,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                        }

                    // let dataSrc = doc.output("datauristring");
                    // let win = window.open("", "myWindow");
                    // win.document.write("<html><head><title>jsPDF</title></head><body><embed src=" +
                    //     dataSrc + "></embed></body></html>");

                    //doc.output('dataurlnewwindow');

                    window.open(URL.createObjectURL(doc.output("blob")))
                } else{

                    var siteSpecific = queryResult.report_details

                    var headers = [
                                    [

                                        {content: 'Terminal Name'},
                                        {content: 'TIN'},
                                        {content: 'TIN Branch Code'},
                                        {content: 'Branch'},
                                        {content: 'Month'},
                                        {content: 'Year'},
                                        {content: 'MIN'},
                                        {content: 'Last OR'},
                                        {content: 'Vatable Sales'},
                                        {content: 'VAT Zero Rated Sales'},
                                        {content: 'VAT Exempt Sales'},
                                        {content: 'Other Taxes'},
                                        {content: 'VAT Amount'},
                                        {content: 'NET Sales'}

                                    ]
                              ];

                    var doc = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'legal' });

                    for(let x=0; x < siteSpecific.length; x++){

                        this.birSalesReports = siteSpecific[x].report_details

                        if(x > 0 && this.birSalesReports.length > 0){
                            doc.addPage();
                        }

                        let reportData = [];

                        if(this.birSalesReports.length > 0){
                            for(let i=0; i < this.birSalesReports.length; i++){

                                let element = this.birSalesReports[i];
                                let detail = [
                                        element.terminal_name,
                                        siteSpecific[x].site_tin,
                                        siteSpecific[x].tin_branch_code,
                                        siteSpecific[x].site_name,
                                        element.month,
                                        element.year,
                                        element.machine_no,
                                        element.last_or,
                                        formatNumber(element.vatable_sales.toFixed(2)),
                                        formatNumber(element.zero_rated_sales),
                                        formatNumber(element.vat_exempt_sales),
                                        formatNumber(element.other_taxes),
                                        formatNumber(element.vat_amount.toFixed(2)),
                                        formatNumber(element.net_sales.toFixed(2))
                                    ]
                                reportData.push(Object.assign({}, detail))

                            }
                        }

                        if (reportData.length == 0) {
                            var pageCount = doc.internal.getNumberOfPages();
                            doc.deletePage(pageCount);
                            continue;
                        }

                        doc.setFontSize(14);
                        doc.setFontType("bold");
                        doc.text(15,20,"BIR Consolidated Report")
                        doc.setFontType("normal");
                        doc.setFontSize(10);
                        doc.text(300,20, siteSpecific[x].site_name);
                        doc.text(15,25,"For the Period of " + this.value[0].format('YYYY-MM')  + " to " + this.value[1].format('YYYY-MM') )

                        doc.autoTable({
                            startY: 40,
                            head: headers,
                            body: reportData,
                            theme: 'plain',
                            tableWidth: 'wrap',
                            headStyles: {
                                // lineWidth: 0.25,
                                cellPadding: 3
                            },
                            styles: {
                                lineWidth: 0.25,
                                cellPadding: 1.0,
                                fontSize: 10,
                                halign: 'right'
                            },
                            columnStyles: {
                                0: {cellWidth: 30},
                                1: {cellWidth: 30},
                                2: {cellWidth: 20},
                                3: {cellWidth: 18},
                                4: {cellWidth: 18},
                                5: {cellWidth: 25},
                                6: {cellWidth: 15},
                                7: {cellWidth: 25},
                                8: {cellWidth: 25},
                                9: {cellWidth: 25},
                                10: {cellWidth: 25},
                                11: {cellWidth: 25},
                                12: {cellWidth: 25},
                                13: {cellWidth: 25},
                            }
                        });

                        doc.text(15,200,"Printed By: " + secureStorage.getItem("email"))
                        doc.text(340,200,"BIR Consolidated Report", "right")

                        doc.text(15,205,"Print Date: " + moment().format("MM/DD/YYYY hh:mm:ssA"))
                        doc.text(340,205,"Page " + ( x + 1)  + " of " + siteSpecific.length, "right")
                        window.open(URL.createObjectURL(doc.output("blob")))
                    }

                }
        this.spinning= false;
        },

        }
    };
</script>

<style></style>
